<cv-layout>
  @if(fontsLoaded){
  <router-outlet />
  }@else {
  <div class="flex items-center justify-center h-[500px]">
    <mat-spinner></mat-spinner>
  </div>
  }
</cv-layout>
